import { INVOICE_TOUR_TARGET_CATALOG, type InvoiceTourTargetKey } from './catalog'
import { CUSTOMIZE_INVOICE_CODE_TOUR_TARGET_KEY } from './customize-invoice-code.targets'
import { CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGET_KEY } from './customize-invoice-template.targets'
import { SETUP_STORE_LOGO_TOUR_TARGET_KEY } from './setup-store-logo.targets'

/** Runtime constants for target-key comparisons (prefer over string literals). */
export const INVOICE_TOUR_TARGET_KEY = {
  ...SETUP_STORE_LOGO_TOUR_TARGET_KEY,
  ...CUSTOMIZE_INVOICE_TEMPLATE_TOUR_TARGET_KEY,
  ...CUSTOMIZE_INVOICE_CODE_TOUR_TARGET_KEY,
} as const satisfies { readonly [K in InvoiceTourTargetKey]: K }

/** All catalog keys — used by contract tests against Contentful seed. */
export const INVOICE_TOUR_TARGET_KEYS = Object.keys(
  INVOICE_TOUR_TARGET_CATALOG,
) as InvoiceTourTargetKey[]
